var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.accordion = new function () {
    var self = this;
    var hidden;
    var url = window.location.href;

    this.init = function () {
        this.setupAccordion();
        this.accordionRow();
        this.onResize();

        if (url.indexOf('#') !== -1) {
            var id = '#' + url.substring(url.lastIndexOf('#') + 1);
            this.smoothScrollAccordion(800, id);
        }
    };

    this.setupAccordion = function () {
        var hash = window.location.hash.slice(1);
        var hashSelector = '#' + hash;
        var winWidth = window.innerWidth;

        if (winWidth < 992) {
            hidden = true;
            $('.js-accordion').hide();
            $('.disabled').removeClass('disabled').addClass('js-accordion').hide();

        } else {
            hidden = false;
            //$('.js-accordion').addClass('disabled').removeClass('js-accordion').show();
        }

        $('.js-load-traffic-info-trigger').on("click", function () {
            Midttrafik2016.forms.routeTrafficInfo.loadTrafficInfo($(this));
        });

        if (hash != "") {
            $(window)
            .on("load", function (e) {
                e.preventDefault();
                $(hashSelector).siblings('.js-accordion').stop().slideToggle();
                $(hashSelector).siblings('.js-accordion-always').stop().slideToggle();
                $(hashSelector).siblings('.js-plus').toggle();
                $(hashSelector).siblings('.js-minus').toggle();
                if ($(hashSelector).hasClass('frontpage-hero-rejseplanen__headline')) {
                    $(hashSelector).toggleClass('frontpage-hero-rejseplanen__headline--open');
                    $(hashSelector).parent().toggleClass('frontpage-hero-rejseplanen--grey');
                }
                Midttrafik2016.forms.routeTrafficInfo.loadTrafficInfo($(hashSelector));
            });
        }

        $('.js-accordion-trigger')
            .on("click", function (e) {
                e.preventDefault();
                $(this).siblings('.js-accordion').stop().slideToggle();
                $(this).siblings('.js-accordion-always').stop().slideToggle();
                $(this).siblings('.js-plus').toggle();
                $(this).siblings('.js-minus').toggle();
                if ($(this).hasClass('frontpage-hero-rejseplanen__headline')) {
                    $(this).toggleClass('frontpage-hero-rejseplanen__headline--open');
                    $(this).parent().toggleClass('frontpage-hero-rejseplanen--grey');
                }
            });

        $('.js-select-option')
            .on("click", function (e) {
                e.preventDefault();
                $(this)
                    .parent('.traffic-info-header-category-select-box')
                    .siblings('.traffic-info-header-category__label')
                    .children('.traffic-info-header-category__span')
                    .html($(this).text());
                $(this)
                    .parent('.search-result-header-category-select-box')
                    .siblings('.search-result-header-category__label')
                    .children('.search-result-header-category__span')
                    .html($(this).text());
                $(this).parent('.js-accordion-always').stop().slideToggle();
            });

        $('.js-read-more')
            .on("click", function (e) {
                e.preventDefault();
                $(this).siblings('.js-accordion').stop().slideToggle();
                $(this).siblings('.js-accordion-always').stop().slideToggle();
                if ($(this).text() == 'Skjul') {
                    $(this).text('Læs mere');
                } else {
                    $(this).text('Skjul');
                }
            });

        $('.bus-schedule-content').on('click', '.js-read-more', function () {
            // The following outcommented lines of codes were related to the old design.
            // $(this).siblings('.js-accordion').stop().slideToggle();
            // $(this).siblings('.js-accordion-always').stop().slideToggle();
            if ($(this).text() == 'Skjul') {
                $(this).text('Læs mere');
            } else {
                $(this).text('Skjul');
            }
        });

    };

    this.onResize = function () {
        var winWidth = window.innerWidth;
        if (winWidth < 992 && !hidden) {
            $('.js-accordion').hide();
            $('.disabled').removeClass('disabled').addClass('js-accordion').hide();
            hidden = true;

        } else if (winWidth > 992 && hidden) {
            $('.js-accordion').addClass('disabled').removeClass('js-accordion').show();
            hidden = false;
        }
    };

    this.accordionRow = function () {
        $('.accordion-row .faq-container-accordion__headline').each(function () {
            var headline = $(this).closest('.accordion-row').find('.accordion-headline');
            $(this).html(headline.text());
            $(this).prop('title', headline.text());
            headline.remove();
        });
    };

    this.smoothScrollAccordion = function (duration, id) {

        //Prevent error with direct linking to quiz
        if(id.startsWith("#?")) {
            return;
        }

        var target = $(id);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, duration);

            var child = id + ' .js-accordion-trigger';

            $(child).siblings('.js-accordion').stop().slideToggle();
            $(child).siblings('.js-accordion-always').stop().slideToggle();
            $(child).siblings('.js-plus').toggle();
            $(child).siblings('.js-minus').toggle();
            if ($(child).hasClass('frontpage-hero-rejseplanen__headline')) {
                $(child).toggleClass('frontpage-hero-rejseplanen__headline--open');
                $(child).parent().toggleClass('frontpage-hero-rejseplanen--grey');
            }

            if ($(child).hasClass('js-load-traffic-info-trigger')) {
                Midttrafik2016.forms.routeTrafficInfo.loadTrafficInfo($(child));
            }

        }
    };
}();
